import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import * as BackstageConstants from '../../../constants';
import * as D from '../../../deps';
import BackstageAlbumGrid from '../../BackstageAlbumGrid';

const integrationData = {
  contentSection: BackstageConstants.BackstageSections.TOP_ALBUMS,
};
const TopAlbumsTitleWithLogger = D.withVisibilityLogger(
  { contentSection: BackstageConstants.BackstageSections.TOP_ALBUMS },
  {
    offsets: {
      bottom: D.Constants.Styling.GlobalStyleConstants.GRID_ITEM_FOOTER_HEIGHT * 3,
    },
  },
)(FormattedMessage);

// @ts-expect-error TS(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
const ArtistTopAlbums = props => {
  const { integration } = useContext(D.AppContext);
  const { topAlbums, albumCount, shareableUrlPath, isMobileDevice } = props;

  if (topAlbums.size <= 0) return null;

  const gridItemCount = isMobileDevice
    ? BackstageConstants.BackstageConstants.NUM_ITEMS_PER_ROW
    : BackstageConstants.BackstageConstants.NUM_ITEMS_PER_ROW_LARGE;
  const moreText =
    albumCount > gridItemCount ? (
      <FormattedMessage {...BackstageConstants.messages.viewAll} />
    ) : null;
  const moreUrl =
    shareableUrlPath && albumCount > gridItemCount
      ? D.getBackstageArtistAllAlbumsPathForShareUrl(shareableUrlPath)
      : null;

  // @ts-expect-error TS(7006) FIXME: Parameter 'e' implicitly has an 'any' type.
  const onSeeAllAlbumsClick = e => {
    integration.action.clicked({
      ...integrationData,
      destinationUrl: e.currentTarget.pathname,
    });
  };

  return (
    <D.AppContextIntegrationData data={integrationData}>
      <D.ContentSection
        isGridList={true}
        title={<TopAlbumsTitleWithLogger {...BackstageConstants.messages.topAlbums} />}
        moreTextOnclick={onSeeAllAlbumsClick}
        moreText={moreText}
        moreUrl={moreUrl}
        disableHover={isMobileDevice}
      >
        <BackstageAlbumGrid pandoraIds={topAlbums} numPlaceholders={gridItemCount} />
      </D.ContentSection>
    </D.AppContextIntegrationData>
  );
};

ArtistTopAlbums.propTypes = {
  topAlbums: ImmutablePropTypes.listOf(PropTypes.string),
  albumCount: PropTypes.number,
  shareableUrlPath: PropTypes.string,
  isMobileDevice: PropTypes.bool,
};

export default ArtistTopAlbums;
